import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import QUERY, {
	type mainIssueHierarchyQuery,
} from '@atlassian/jira-relay/src/__generated__/mainIssueHierarchyQuery.graphql';

export const issueHierarchyPageResource = createRelayResource<mainIssueHierarchyQuery>({
	type: 'RESOURCE1',
	getQuery: (_, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
		},
	}),
});
